import axiosInstance from "./axios";

export const createNotification = async (data) => {
    const response = await axiosInstance.post("/notification/create", data);
    return response.data;
};

export const getNotifications = async (params) => {
    const response = await axiosInstance.get("/notification/find", { params });
    return response.data;
};

export const updateNotification = async (id, data) => {
    const response = await axiosInstance.put(`/notification/update/${id}`, data);
    return response.data;
};

export const deleteNotification = async (id) => {
    const response = await axiosInstance.delete(`/notification/delete/${id}`);
    return response.data;
};

export const deleteMultipleNotifications = async (ids) => {
    const response = await axiosInstance.post("/notification/delete-multiple", { ids });
    return response.data;
};